module.exports = __webpack_public_path__ + "static/media/mandibular-set2dev.9f2e1b5f.png";